module.exports = __webpack_public_path__ + "static/favicon-e6af4cf23387d3902eae2ad8dee2c5e5.ico";